import { useEffect } from 'react';
import { Divider, Box } from '@mantine/core';
import { IconPhotoOff } from '@tabler/icons-react';
import * as actions from '../../../actions/Lote';
import EmptyState from '../../../components/EmptyState';
import PhotoViewer from '../../../components/PhotoViewer';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { DetailSkeleton } from '../../../components/TableSkeleton';

export default function Fotos() {
  const dispatch = useAppDispatch();
  const loteSelectedId = useAppSelector((state) => state.lote.loteSelectedId);
  const photos = useAppSelector((state) => state.lote.photos);
  const loading = useAppSelector((state) => state.container.loading);

  useEffect(() => {
    if (loteSelectedId) {
      dispatch((actions as any).getPhotos(loteSelectedId));
    }
  }, [loteSelectedId, dispatch]);

  if (loading && !photos) return <DetailSkeleton lines={4} />;
  if (!photos) return null;

  const fotos = photos.fotos || [];
  const thumbs = photos.thumbs || [];
  const dates = photos.dates || [];

  if (fotos.length === 0) {
    return (
      <Box mt="md">
        <EmptyState label="Não há fotos" icon={IconPhotoOff} mih={160} />
      </Box>
    );
  }

  return (
    <Box>
      <Divider my="md" />
      <PhotoViewer fotos={fotos} thumbs={thumbs} dates={dates} className="list-fotos" />
    </Box>
  );
}
